import type { Theme } from "../..";

/**
 * `useGlobalTheme()`
 *
 * Returns global theme definition and its primitives values.
 */
function useGlobalTheme(themeFile: Theme.GriddoTheme): Theme.GlobalTheme {
	return themeFile.global;
}

export { useGlobalTheme };
